import { CreativeCardSkeleton } from "./CreativeCardSkeleton";

interface CreativesGridSkeletonProps {
  count?: number;
}

export function CreativesGridSkeleton({
  count = 8,
}: CreativesGridSkeletonProps) {
  return (
    <div
      className="mt-10 grid gap-6"
      style={{ gridTemplateColumns: "repeat(auto-fill, minmax(260px, 1fr))" }}
    >
      {Array.from({ length: count }).map((_, idx) => (
        <CreativeCardSkeleton key={idx} />
      ))}
    </div>
  );
}
